import { RootState } from '../index';
import { IListRoleState } from './types';

export function listRoleSelector(state: RootState): IListRoleState {
  return state.role.listRole;
}
